import { TableRow, UserStoreTables } from './tinybase';

export type HousingApplication = Override<
  TableRow<UserStoreTables, 'housingApplications'>,
  {
    offerFlag: ApplicationOfferFlag;
    nominationFlag: ApplicationNominationFlag;
  }
>;

export type FullHousingApplication = HousingApplication & {
  applicantPersonIds: number[];
  points: number;
};

export type ApplicationApplicant = TableRow<UserStoreTables, 'applicationApplicants'>;

export type ApplicationAllocation = TableRow<UserStoreTables, 'applicationAllocations'>;

/** Values are a subset of those found in NEC FSC.STATUS_CODES */
export const ScoCodes = ['NEW', 'CUR', 'CLD', 'HSD'];

/**
 * There doesn't seem to be reference values for this flag in NEC,
 * just an enum constraint on HOU.APPLICATIONS.APP_OFFER_FLAG
 * */
export type ApplicationOfferFlag = 'N' | 'O' | 'A';

/**
 * There doesn't seem to be reference values for this flag in NEC,
 * just an enum constraint on HOU.APPLICATIONS.APP_NOMINATION_FLAG
 * */
export type ApplicationNominationFlag = 'N' | 'O' | 'A';
